module.exports = __webpack_public_path__ + "static/media/portaDrzwi.3dd51fc1.png";